import React, { Component } from "react";
import { HeaderTop } from "../../components";
import { QuestionnaireAnswer } from "./QuestionnaireAnswer";
import { QuestionnaireRating } from "./QuestionnaireRating";
import { QuestionnaireYesNo } from "./QuestionnaireYesNo";
import { QUESTION_TYPES } from "../../config/constants";
import QuestionnaireProgress from "../../components/QuestionnaireProgress";
import { connect } from "react-redux";
import { createAnswer } from "../../actions/answer";
import { getFeed } from "../../actions/user";
import "./styles.css";

class Questionnaire extends Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.questionnaires.length !== this.props.questionnaires.length) {
      this.setState(this.getInitialState());
    }
  }

  getInitialState() {
    const { questionnaires, match } = this.props;
    const { id } = match.params;

    return {
      question: questionnaires[id - 1] || {}
    };
  }

  renderQuestion = question => {
    switch (question.type) {
      case QUESTION_TYPES.RATING:
        return <QuestionnaireRating data={question} />;

      case QUESTION_TYPES.YESNO:
        return <QuestionnaireYesNo data={question} />;

      case QUESTION_TYPES.ANSWER:
      default:
        return <QuestionnaireAnswer data={question} />;
    }
  };

  renderClass = type => {
    switch (type) {
      case QUESTION_TYPES.RATING:
        return "questionnaire-rating";

      case QUESTION_TYPES.YESNO:
        return "questionnaire-yesno";

      case QUESTION_TYPES.ANSWER:
      default:
        return "questionnaire-answer";
    }
  };

  onNext = isFinal => {
    const { history, match, questionnaires, answers } = this.props;
    const { id } = match.params;

    this.props.createAnswer({
      complete: isFinal,
      question: questionnaires[id - 1]._id,
      answers: answers[+id - 1]
    });
    if (isFinal) {
      history.push("/journal");
    } else {
      history.push(`/questionnaire/${+id + 1}`);
    }
  };

  render() {
    const { question } = this.state;
    const { history, questionnaires, answers } = this.props;
    const { id } = this.props.match.params;
    const isFinal = +id === questionnaires.length;

    return (
      <div className="questionnaire-wrap">
        <HeaderTop />

        <div className={`questionnaire ${this.renderClass(question.type)}`}>
          <QuestionnaireProgress questionnaires={questionnaires} />
          {this.renderQuestion(question)}
          <div className="content-bottom">
            <div className="content">
              <button className="bttn-link" onClick={() => history.goBack()}>
                Назад
              </button>
              <button className="bttn" onClick={() => this.onNext(isFinal)}>
                {isFinal ? "Завърши" : "Продължи"}
              </button>
            </div>
          </div>
        </div>

        <div className="bg-1" />
        <div className="bg-2" />
      </div>
    );
  }
}

const mstp = state => ({
  questionnaires: state.question.collection,
  answers: state.answer.collection
});

const mdtp = dispatch => ({
  createAnswer: payload => dispatch(createAnswer(payload)),
  getFeed: () => dispatch(getFeed())
});

export default connect(
  mstp,
  mdtp
)(Questionnaire);



// WEBPACK FOOTER //
// ./src/screens/Questionnaire/Questionnaire.js